import VlocIsOnItsWayScreen from 'features/lineOfCredit/screens/vlocIsOnItsWay/VlocIsOnItsWayScreen';
import React from 'react';

export default function Page() {
  return <VlocIsOnItsWayScreen serializedData={undefined} />;
}
